module.exports = __webpack_public_path__ + "static/media/semitrailer-1.5ecf302e.png";